import React from "react";
import ExchangeRates from "./ExchangeRates";
import LastCost from "./LastCost";
import Efficiency from "./Efficiency";
import {
  Search,
  Hexagon,
  Home,
  StatisticUp,
  Envelope,
  Person,
  File,
  PanelSplit,
  TextAlignJustified,
  Bell,
} from "akar-icons";

export default function BrowserCMS() {
  return (
    <section className="browser-cms">
      <nav className="navbar-browser">
        <div className="navbar-brand" href="/">
          <div className="icon-container">
            <Hexagon strokeWidth={2} size={24} />
          </div>
          <span className="name">Financial CRM</span>
        </div>
        <ul className="navbar-nav">
          <li>
            <div className="active">
              <Home strokeWidth={2} size={20} />
              <span>Home</span>
            </div>
          </li>
          <li>
            <div>
              <StatisticUp strokeWidth={2} size={20} />
              <span>Statistics</span>
            </div>
          </li>
          <li>
            <div>
              <Envelope strokeWidth={2} size={20} />
              <span>Messages</span>
            </div>
          </li>
          <li>
            <div>
              <Person strokeWidth={2} size={20} />
              <span>Profile</span>
            </div>
          </li>
          <li>
            <div>
              <File strokeWidth={2} size={20} />
              <span>Documents</span>
            </div>
          </li>
        </ul>
        <div className="navbar-footer">
          <div className="container">
            <h2>PDF Report</h2>
            <span>Annual detailed report</span>
            <a href="/" download>
              Download
            </a>
          </div>
        </div>
      </nav>
      <main>
        <header>
          <section role="search">
            <form action="#" method="get">
              <div className="form-inline">
                <Search strokeWidth={2} size={16} />
                <input type="search" placeholder="Search" />
              </div>
            </form>
          </section>
          <section role="application">
            <button className="change-view">
              <PanelSplit strokeWidth={2} size={16} />
              Change view
            </button>
            <button className="notification">
              <Bell strokeWidth={2} size={16} />
            </button>
            <button className="menu">
              <TextAlignJustified strokeWidth={2} size={16} />
            </button>
          </section>
        </header>
        <h1>Overview</h1>
        <div className="charts-wrapper">
          <section role="credit-card">
            <div className="top-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="22"
                viewBox="0 0 36 22"
                fill="none"
              >
                <rect
                  width="22"
                  height="22"
                  rx="11"
                  fill="#D9D9D9"
                  fillOpacity="0.5"
                />
                <rect
                  x="14"
                  width="22"
                  height="22"
                  rx="11"
                  fill="#D9D9D9"
                  fillOpacity="0.5"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="11"
                viewBox="0 0 28 11"
                fill="none"
              >
                <g clipPath="url(#clip0_71_217)">
                  <path
                    d="M5.11896 1.41817C4.79084 1.78972 4.26584 2.08278 3.74084 2.04091C3.67521 1.53853 3.93224 1.00476 4.23302 0.675071C4.56115 0.293054 5.13537 0.0209324 5.60021 0C5.6549 0.523311 5.44162 1.03616 5.11896 1.41817ZM5.59474 2.14034C4.83459 2.09848 4.1838 2.55376 3.82287 2.55376C3.45646 2.55376 2.90412 2.16127 2.30255 2.17174C1.52052 2.18221 0.793179 2.60609 0.39396 3.28116C-0.426352 4.6313 0.180679 6.63035 0.973648 7.72931C1.36193 8.27355 1.82677 8.87012 2.43927 8.84919C3.01896 8.82826 3.24865 8.48811 3.94865 8.48811C4.65412 8.48811 4.85646 8.84919 5.46896 8.83872C6.10334 8.82826 6.50255 8.29448 6.89084 7.75024C7.3338 7.13273 7.51427 6.53092 7.52521 6.49952C7.51427 6.48906 6.30021 6.04424 6.28927 4.70457C6.27834 3.58468 7.2463 3.0509 7.29005 3.01951C6.74318 2.245 5.89005 2.16127 5.59474 2.14034ZM9.98615 0.62274V8.78116H11.3096V5.99191H13.1416C14.8151 5.99191 15.9908 4.89296 15.9908 3.30209C15.9908 1.71123 14.8369 0.62274 13.1854 0.62274H9.98615ZM11.3096 1.69029H12.8354C13.9838 1.69029 14.6401 2.2764 14.6401 3.30733C14.6401 4.33825 13.9838 4.92959 12.8299 4.92959H11.3096V1.69029ZM18.408 8.84396C19.2393 8.84396 20.0104 8.44101 20.3604 7.80257H20.3877V8.78116H21.6127V4.72027C21.6127 3.54282 20.6283 2.78402 19.1135 2.78402C17.708 2.78402 16.669 3.55328 16.6307 4.61037H17.8229C17.9213 4.10799 18.408 3.77831 19.0752 3.77831C19.8846 3.77831 20.3385 4.13939 20.3385 4.804V5.25404L18.6869 5.34824C17.1502 5.4372 16.319 6.03901 16.319 7.08563C16.319 8.14272 17.1776 8.84396 18.408 8.84396ZM18.7635 7.87583C18.058 7.87583 17.6096 7.55138 17.6096 7.05423C17.6096 6.54139 18.0416 6.2431 18.8674 6.196L20.3385 6.10704V6.56755C20.3385 7.33159 19.6604 7.87583 18.7635 7.87583ZM23.2479 11C24.5385 11 25.1455 10.529 25.676 9.10038L28.0002 2.86251H26.6549L25.0963 7.68221H25.069L23.5104 2.86251H22.1268L24.369 8.80209L24.2486 9.16318C24.0463 9.77545 23.7182 10.0109 23.133 10.0109C23.0291 10.0109 22.8268 10.0005 22.7447 9.99001V10.9686C22.8213 10.9895 23.1494 11 23.2479 11Z"
                    fill="white"
                    fillOpacity="0.4"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_71_217">
                    <rect width="28" height="11" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="ccNumber">
              <span>˙˙˙˙ ˙˙˙˙ ˙˙˙˙ 5610</span>
            </div>
            <div className="ccBottom">
              <div className="ccValidThru">
                <label>VALID THRU</label>
                <span>05/21</span>
              </div>
              <div className="ccCardHolder">
                <label>CARD HOLDER</label>
                <span>Robert</span>
              </div>
            </div>
          </section>
          <section role="chart" className="exchange-rates">
            <h3 className="title">Exchange rates</h3>
            <ExchangeRates />
          </section>
          <section role="chart" className="last-costs">
            <h3 className="title">Last Costs</h3>
            <LastCost />
          </section>
          <section role="chart" className="efficiency">
            <h3 className="title">Efficiency</h3>
            <Efficiency />
          </section>
        </div>
      </main>
    </section>
  );
}
